import { initializeAuthCallbacks } from '@sit/client-shared';
import { useEffect } from 'react';
import { useNavigate } from 'react-router';

function deleteCookies() {
  // eslint-disable-next-line @microsoft/sdl/no-cookies -- we are deleting cookies, so the warning to not use cookies is not applicable
  const Cookies = document.cookie.split(';');
  for (const cookie of Cookies) {
    // eslint-disable-next-line @microsoft/sdl/no-cookies -- we are deleting cookies, so the warning to not use cookies is not applicable
    document.cookie = `${cookie}=;expires=${new Date(0).toUTCString()}`;
  }
}

export function useInitializeLogoutHandler() {
  const navigate = useNavigate();
  // biome-ignore lint/correctness/useExhaustiveDependencies: navigate is not a dependency
  useEffect(() => {
    initializeAuthCallbacks({
      onLogout: () => {
        sessionStorage.clear();
        localStorage.clear();
        deleteCookies();
        navigate('/saml');
      },
    });
  }, []);
}
